import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@workspace/frontend-ui";
import type InfoTooltipProps from "./types";

const DesktopInfoTooltip: FC<InfoTooltipProps> = ({ trigger, content }) => (
  <HoverCard openDelay={0} closeDelay={0}>
    <HoverCardTrigger asChild>
      <span>{trigger}</span>
    </HoverCardTrigger>
    <HoverCardContent className="w-auto p-4">{content}</HoverCardContent>
  </HoverCard>
);

export default DesktopInfoTooltip;
